import { render, staticRenderFns } from "./grupos.vue?vue&type=template&id=48b59550&scoped=true"
import script from "./grupos.vue?vue&type=script&lang=js"
export * from "./grupos.vue?vue&type=script&lang=js"
import style0 from "./grupos.vue?vue&type=style&index=0&id=48b59550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b59550",
  null
  
)

export default component.exports